import React from 'react';
import TopBar from './header/TopBar';
import NavBar from './header/NavBar';

export default class Header extends React.Component {
	render() {
		return (
			<header className="hd-wrap">
				<TopBar />
				<NavBar />
			</header>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/Header.js